var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header_cont"},[_c('div',{staticClass:"cont_text w_1200"},[_c('p',{staticClass:"tips"},[_vm._v(_vm._s(_vm.tips))]),_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])])])}
var staticRenderFns = []

export { render, staticRenderFns }